import { useState } from "react";

import {
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Checkbox,
  FormControlLabel,
  Button,
  FormLabel,
  Box,
} from "@material-ui/core";

import Api from "lib/api/httpRequestHelper";
import { IsMobile } from "utils/is-mobile";
import DocumentPreview from "components/_refactor/document-preview";

export default function DialogPopUpInfo({ infos, open, setOpenDialog }) {
  const isMobile = IsMobile();
  const [acept, setAcept] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async () => {
    setSubmitting(true);
    try {
      await Api.post(
        "verify-notification-user",
        "conteudo",
        {
          idDocumentoArea: infos.IdDocumentoArea,
          ...(infos.AceiteDoUsuario ? { aceite: acept } : {}),
          notificado: true,
        },
        true
      );
      setOpenDialog();
    } catch (error) {
      console.log(error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      open={open}
      maxWidth="md"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <Typography variant="h3" component="h3">
          {infos.Titulo}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="h5" component="h5">
          {infos.Descricao}
        </Typography>
        {infos.UrlArquivo && (
          <Box
            mb={2}
            border="1px solid #e0e0e0"
            borderRadius={4}
            overflow="hidden"
          >
            <DocumentPreview url={infos.UrlArquivo} />
          </Box>
        )}
        <Grid container spacing={2} style={{ marginBottom: "1rem" }}>
          {infos.AceiteDoUsuario && (
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={acept}
                    onChange={(e) => setAcept(e.target.checked)}
                    name="acept"
                    color="primary"
                    disabled={submitting}
                  />
                }
                style={{ margin: 0 }}
                label={<FormLabel>Li e aceito os termos acima</FormLabel>}
              />
            </Grid>
          )}
          <Grid item xs={12} alignItems="flex-end">
            <Button
              color="default"
              variant="contained"
              type="submit"
              disabled={submitting || (infos.AceiteDoUsuario && !acept)}
              onClick={onSubmit}
              style={isMobile ? { width: "100%" } : { width: "fit-content" }}
            >
              {submitting ? "Enviando..." : "Enviar"}
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
